export default __webpack_public_path__ + "static/media/rnr-sports-table-12-cn.eb2f3928.webp";